import { Box, Paper, Typography } from "@mui/material";
import { ReactNode } from "react";

/**
 * One titled block of the page.
 *
 * The heading is the same muted overline the fill, fill-history and activity
 * sections next to it already use, and the one the waste specs draw for every
 * section — this card was the odd one out with an h6.
 */
export function SectionCard({ title, children }: { title: string; children: ReactNode }) {
  return (
    <Paper elevation={0} sx={{ p: 3, height: "100%" }}>
      <Typography
        variant="overline"
        color="text.secondary"
        sx={{ letterSpacing: "1px", mb: 2, display: "block" }}
      >
        {title}
      </Typography>
      {children}
    </Paper>
  );
}

/** Muted empty-state box for a section with nothing to show. */
export function EmptySectionState({ message }: { message: string }) {
  return (
    <Box
      sx={{
        py: 4,
        textAlign: "center",
        backgroundColor: "grey.50",
        borderRadius: 1,
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {message}
      </Typography>
    </Box>
  );
}
